import React, { PureComponent } from 'react';
import defaultMsg from '../../../src/translations/lang/en-US.json';
import Login from './Login';
import Register from './Register';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

class SignInModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLogin: true,
            loginClass: 'active  no-selection',
            registerClass: 'no-selection',
        };
    }

    showLogin = () => {
        this.setState({
            isLogin: true,
            loginClass: 'active no-selection',
            registerClass: 'no-selection',
        });
    }

    showRegister = () => {
        this.setState({
            isLogin: false,
            loginClass: 'no-selection',
            registerClass: 'active no-selection',
        });
    }

    onHide = () => {
        const { onHide } = this.props;
        this.showLogin();
        if(onHide)
            onHide();
    }

    loginShow = () => {
        this.showLogin();
    }

    registerShow = () => {
        this.showRegister();
    }

    error = (msg) => {
        const { error } = this.props;
        if(error)
            error(msg);
    }

    success = (msg) => {
        const { success } = this.props;
        if(success)
            success(msg);
    }

    showForgotPasswordModal = (type) => {
        const { showForgotPasswordModal } = this.props;
        if(showForgotPasswordModal)
            showForgotPasswordModal(type);
    }

    render() {
        const { show, lavuToGoName, signInCaller } = this.props;
        const { loginClass, registerClass, isLogin } = this.state;
        return (
            <Modal show={show} 
                   onHide={this.onHide}
                   animation={true}
                   dialogClassName="sign-in-modal" 
            >
                <Modal.Header closeButton>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel-login panel-color">
                                <div className="panel-heading">
                                    <div className="row">
                                        <div className="col-md-6 col-xs-6" style={{ textAlign: 'right' }} >
                                            <a className={loginClass}
                                               onClick={this.loginShow}
                                               id="login-form-link" 
                                            >
                                                <FormattedMessage id="signIn" defaultMessage={defaultMsg.signIn} />
                                            </a>
                                        </div>
                                        <div className="col-md-6 col-xs-6" style={{ textAlign: 'left' }} >
                                            <a className={registerClass}
                                               id="register-form-link"
                                               onClick={this.registerShow}
                                            >
                                                <FormattedMessage id="register"
                                                                  defaultMessage={defaultMsg.register}
                                                />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-b ">
                    <div className="row">
                        <div className="col-md-12 ">
                            { isLogin ? 
                                <Login hideSignInModal={this.onHide} 
                                       error={this.error}
                                       success={this.success}
                                       rname={lavuToGoName}
                                       signInCaller={signInCaller}
                                       showForgotPasswordModal={this.showForgotPasswordModal}
                                />
                            : 
                                <Register hideModal={this.onHide} 
                                          error={this.error}
                                          success={this.success}
                                          rname={lavuToGoName}
                                          registerCaller={signInCaller}
                                /> 
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        ); 
    }
}

export default SignInModal;


// WEBPACK FOOTER //
// ./src/views/auth/SignInModal.jsx